import { useState, useEffect } from 'react';

interface SafeAreaInsets {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

export const useSafeArea = () => {
  const [insets, setInsets] = useState<SafeAreaInsets>({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  });

  useEffect(() => {
    const updateInsets = () => {
      const style = getComputedStyle(document.documentElement);

      const parseValue = (prop: string): number => {
        const value = style.getPropertyValue(prop).trim();
        if (!value || value === '0' || value === '0px') return 0;
        const parsed = parseFloat(value.replace('px', ''));
        return isNaN(parsed) ? 0 : Math.round(parsed);
      };

      setInsets({
        top: parseValue('--safe-area-inset-top'),
        right: parseValue('--safe-area-inset-right'),
        bottom: parseValue('--safe-area-inset-bottom'),
        left: parseValue('--safe-area-inset-left'),
      });
    };

    updateInsets();
    window.addEventListener('resize', updateInsets);
    window.addEventListener('orientationchange', updateInsets);

    return () => {
      window.removeEventListener('resize', updateInsets);
      window.removeEventListener('orientationchange', updateInsets);
    };
  }, []);

  return insets;
};
